import Core from '../../core/tracking/core';
import Utils from '../../core/utils';

export default class CoreCustom extends Core {
  getCustomer = (sessionInfo) => {
    const {customer} = sessionInfo.context;

    const data = window.dataLayer?.[0] || [];
    if (!data) return customer;

    const {fid_id, programFid} = data;
    if (fid_id) customer.fid_points = fid_id;
    if (programFid) customer.fid_status = programFid;

    const query = Utils.getQueryString('utm_campaign');

    if (!query) return customer;

    const reg = /T3(\d+)$/;
    const res = reg.exec(query);
    if (!res || res.length < 2) {
      return customer;
    }

    customer.customer_reference = res[1];

    return customer;
  }

  initProductEvent = () => {
    this.navTracking.onProductPageView();

    const addbuttons = document.querySelectorAll('button.add-to-cart');
    for (let i = 0; i < addbuttons.length; i++) {
      addbuttons[i].addEventListener('click', () => {
        setTimeout(() => {
          WIO.track('addToBasket', '', '');
        }, 3000)
      }, false);
    }
  }
}

window.WIO = new CoreCustom();
